<template>
    <div style="position: relative">
        <Spin v-if="pageLoading" fix size="large"></Spin>
        <Row class="row">
            <Col span="4">
                <label class="title-label">标签名称</label>
            </Col>
            <Col span="8" offset="1">
                <label class="title-label">所属模块</label>
            </Col>
            <Col span="4" offset="1">
                <label class="title-label">所属分类</label>
            </Col>
            <Col span="4" offset="1">
                <label class="title-label">操作</label>
            </Col>
        </Row>

        <div v-for="(tag,index) in tagList">
            <Form :ref="'tag'+index" :model="tagList[index]" :rules="rule">
                <Row>
                    <Col span="4">
                        <FormItem prop="tagname">
                            <Input v-model="tag.tagname" placeholder="请填写标签名称"></Input>

                        </FormItem>
                    </Col>

                    <Col span="8" offset="1">
                        <FormItem prop="istype">
                            <Input readonly v-model="tag.istypestr" @on-focus="showTagModel(index)" placeholder="请选择所属模块" :title="tag.istypestr"></Input>
                            <input type="hidden" v-model="tag.istype" />
                        </FormItem>
                    </Col>

                    <Col span="4" offset="1">
                        <FormItem prop="tagtype">
                            <Select clearable v-model="tag.tagtype" placeholder="请选择所属分类">
                                <Option v-for="type in typeList" :value="type.id" :key="type.id">{{type.tagname}}</Option>
                            </Select>
                        </FormItem>
                    </Col>

                    <Col span="4" offset="1">
                        <Button type="default" style="background-color: #fff;" @click="deleteOne(index)" class="btn-del">删除</Button>
                    </Col>
                </Row>
            </Form>
        </div>

        <Row>
            <Col span="4">
            <button class="add-one-btn" @click="addOne"><i class="fa fa-plus"></i>添加标签</button>
            </Col>
        </Row>

        <div class="save-btn">
            <Button type="primary" style="width: 150px" :loading="loadingStatus" @click="saveTag">保存</Button>
        </div>

        <!--modal-->
        <Modal v-model="modalStatus" title="请选择所属模块" @on-ok="modalOk" :mask-closable="false">
            <CheckboxGroup v-model="modalData">
                <div class="_tag_list_modal_one">
                    <Row>
                        <Col span="4" offset="6">
                            <label>土地</label>
                        </Col>
                        <Col span="4">
                            <Checkbox label="11">项目</Checkbox>
                        </Col>
                        <Col span="4" offset="1">
                            <Checkbox label="21">载体</Checkbox>
                        </Col>
                    </Row>
                </div>
                <div class="_tag_list_modal_one">
                    <Row>
                        <Col span="4" offset="6">
                            <label>厂房</label>
                        </Col>
                        <Col span="4">
                            <Checkbox label="12">项目</Checkbox>
                        </Col>
                        <Col span="4" offset="1">
                            <Checkbox label="22">载体</Checkbox>
                        </Col>
                    </Row>
                </div>
                <div class="_tag_list_modal_one">
                    <Row>
                        <Col span="4" offset="6">
                            <label>仓库</label>
                        </Col>
                        <Col span="4">
                            <Checkbox label="17">项目</Checkbox>
                        </Col>
                        <Col span="4" offset="1">
                            <Checkbox label="27">载体</Checkbox>
                        </Col>
                    </Row>
                </div>
                <div class="_tag_list_modal_one">
                    <Row>
                        <Col span="4" offset="6">
                            <label>写字楼</label>
                        </Col>
                        <Col span="4">
                            <Checkbox label="14">项目</Checkbox>
                        </Col>
                        <Col span="4" offset="1">
                            <Checkbox label="24">载体</Checkbox>
                        </Col>
                    </Row>
                </div>
                <div class="_tag_list_modal_one">
                    <Row>
                        <Col span="4" offset="6">
                            <label>企业</label>
                        </Col>
                        <Col span="4">
                            <Checkbox label="31">企业</Checkbox>
                        </Col>
                    </Row>
                </div>
<!--                <div class="_tag_list_modal_one">-->
<!--                    <Row>-->
<!--                        <Col span="4" offset="10">-->
<!--                            <a @click="selectAll('item')">全部项目</a>-->
<!--                        </Col>-->
<!--                        <Col span="4" offset="1">-->
<!--                            <a @click="selectAll('carrier')">全部载体</a>-->
<!--                        </Col>-->
<!--                    </Row>-->
<!--                </div>-->
            </CheckboxGroup>
        </Modal>

        <!--warning-->
        <warning ref="delwarn" :title="warningMsg.title" @callback="deleteTag">
            <div  slot="body">
                <div class="warning-item">
                    <p>{{warningMsg.tip}}</p>
                </div>
                <div class="warning-item">
                    <Form>
                        <FormItem label="转移数据">
                            <RadioGroup v-model="warningMsg.is_transfer">
                                <Radio label="1">是</Radio>
                                <Radio label="2">否</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="转移到" v-if="warningMsg.is_transfer === '1'">
                            <Select v-model="warningMsg.tag_id" placeholder="请选择所属分类" style="width: 200px;">
                                <Option v-for="(type,index) in tagList" v-if="warningMsg.delindex != index" :value="type.id" :key="type.id">{{type.tagname}}</Option>
                            </Select>
                        </FormItem>
                    </Form>
                </div>
            </div>

        </warning>
    </div>
</template>

<script>
    import Warning from "@/components/warningModal/Warning.vue";
    import tagListValidate from "@/validateRule/company/tagList";
    import utils from "@/utils";
    import $api from "@/service";

    export default {
        components:{
            Warning
        },
        data(){
            return {
                pageLoading : true,
                loadingStatus : false,
                //标签列表
                tagList : [],
                //备选分类列表
                typeList : [],
                //验证规则
                rule : tagListValidate,
                //模态框状态
                modalStatus: false,
                //模态框数据
                modalData : [],
                //模态框index
                modalIndex : -1,
                //删除框
                warningMsg : {
                    delindex :"",
                    title : "删除确认",
                    tip : "",
                    is_transfer : "1",
                    tag_id : "",
                },
            }
        },
        created(){
            this.getTypeList();
            this.getTagList();
        },
        methods:{
            //获取备选分类
            getTypeList(){
                let _self = this;
                $api.getTagType().then(data=>{
                    _self.typeList = data;
                });
            },
            //获取标签列表
            getTagList(){
                let _self = this;
                this.pageLoading = true;
                $api.getTagList().then(data=>{
                    _self.pageLoading = false;
                    for(let e of data){
                        e.istype = e.istype===""? [] : e.istype.split(",");
                    }
                    _self.tagList = data;
                });
            },
            /**
             * 删除一个
             * @param {int} index 删除项的索引
             */
            deleteOne(index){
                // this.tagList.splice(index,1);
                if(this.tagList[index].id ===""){
                    this.tagList.splice(index,1);
                }else{
                    this.warningMsg = {
                        delindex :"",
                        title : "删除确认",
                        tip : "",
                        is_transfer : "1",
                        tag_id : "",
                    };
                    this.warningMsg.delindex = index;
                    this.warningMsg.tip = "您确认删除 " + this.tagList[index].tagname + " 标签？";
                    this.warningMsg.tag_id = "";
                    this.$refs.delwarn.show();
                }
            },
            //删除标签确认
            deleteTag(){
                if(this.warningMsg.is_transfer === "1" && this.warningMsg.tag_id === ""){
                    utils.notice("请选择转移到",'error');
                    return false;
                }
                this.$refs.delwarn.doLoading();
                let postData = {
                    "id"            :   this.tagList[this.warningMsg.delindex].id,
                    "is_transfer"   :   this.warningMsg.is_transfer,
                    "tag_id"        :   this.warningMsg.is_transfer === "1" ? this.warningMsg.tag_id : "",
                };
                let _self = this;
                //axios
                $api.deleteTag(postData).then(data=>{
                    _self.$refs.delwarn.noLoading();
                    _self.$refs.delwarn.hide();
                    if(data.code === "200"){
                        _self.tagList.splice(_self.warningMsg.delindex,1);
                        _self.warningMsg = {
                            delindex :"",
                            title : "删除确认",
                            tip : "",
                            is_transfer : "1",
                            tag_id : "",
                        };
                        utils.notice("删除成功","success");
                    }else{
                        utils.notice(data.msg,"error");
                    }
                });

            },
            //添加一个
            addOne(){
                this.tagList.push({
                    "id"        :   "",
                    "tagname"   :   "",
                    "tagtype"   :   "",
                    "istype"    :   [],
                    "istypestr" :   "",
                });
                this.tagList = [].concat(this.tagList);
            },
            /**
             * 显示modal
             * @param {int} index 操作项的id
             */
            showTagModel(index){
                this.modalData = this.tagList[index].istype;
                this.modalIndex = index;
                this.$nextTick(()=>{
                    this.modalStatus = true;
                });

            },
            //modal确认
            modalOk(){
                this.tagList[this.modalIndex].istype = this.modalData ? this.modalData : [];
                this.tagList[this.modalIndex].istypestr = this.getIstypeStr(this.modalData);
                this.modalStatus = false;
            },
            /**
             * 根据istype自动获取istyoestr
             * @param {array} data 模态框数据
             * @returns {string}
             */
            getIstypeStr(data){
                if(!data || data.length <= 0){
                    return "";
                }
                let arr = [];
                let str = "";
                for (let i=0;i<data.length;i++){
                    let one = "";
                    switch(data[i]){
                        case "11":
                            one = "土地项目";
                            break;
                        case "21":
                            one = "土地载体";
                            break;
                        case "12":
                            one = "厂房项目";
                            break;
                        case "22":
                            one = "厂房载体";
                            break;
                        case "17":
                            one = "仓库项目";
                            break;
                        case "27":
                            one = "仓库载体";
                            break;
                        case "14":
                            one = "写字楼项目";
                            break;
                        case "24":
                            one = "写字楼载体";
                            break;
                        case "31":
                            one = "企业";
                            break;
                        default:
                            break;
                    }
                    arr.push(one);
                }
                str = arr.join("/");
                return str;
            },
            /**
             * modal全选
             * @param {string} type 分类
             */
            selectAll(type){
                if(type === "item"){
                    //项目
                    let itemArr = ["11","12"];
                    //取交集判断是否全选
                    if([...new Set([...new Set(itemArr)].filter(x=>new Set(this.modalData).has(x)))].sort().toString() === itemArr.sort().toString()){
                        //取差集
                        this.modalData = [...new Set([...new Set(this.modalData)].filter(x=>!new Set(itemArr).has(x)))];
                    }else{
                        // this.modalData = this.modalData.concat([
                        //     "11","12","17","14","13","15","110"
                        // ]);
                        this.modalData = this.modalData.concat([
                            "11","12"
                        ]);
                    }
                }else if(type === "carrier"){
                    //载体
                    let carrierArr = ["21","22"];
                    //取交集判断是否全选
                    if([...new Set([...new Set(carrierArr)].filter(x=>new Set(this.modalData).has(x)))].sort().toString() === carrierArr.sort().toString()){
                        //取差集
                        this.modalData = [...new Set([...new Set(this.modalData)].filter(x=>!new Set(carrierArr).has(x)))];
                    }else{
                        this.modalData = this.modalData.concat([
                            "21","22"
                        ]);
                    }

                }
                this.modalData = Array.from(new Set(this.modalData));
                console.log(this.modalData);
            },
            //保存
            saveTag(){

                let res = true;
                if(this.tagList.length<=0){
                    utils.notice("请添加标签","error");
                    return false;
                }
                for(let i = 0 ; i < this.tagList.length; i++){
                    this.$refs["tag"+i][0].validate((valid) => {
                        if (!valid) {
                            res = false;
                        }
                    })
                }
                if(!res){
                    utils.notice("您还有信息未填写或未验证通过","error");
                    return false;
                }

                //整理数据并提交
                let postData = [];
                for(let e of this.tagList){
                    postData.push({
                        "id"        :   e.id ? e.id : "",
                        "tagname"   :   e.tagname ? e.tagname : "",
                        "tagtype"   :   e.tagtype ? e.tagtype : "",
                        "istype"    :   e.istype ? e.istype : [],
                    });
                }
                //axios
                this.loadingStatus = true;
                let _self = this;
                $api.saveTagList(postData).then(data=>{
                    _self.loadingStatus = false;
                    if(data.code === "200"){
                        utils.message({title:"保存成功"},"success");
                        _self.getTagList();
                    }else{
                        utils.message({title:data.msg},"error");
                    }
                });
            },
        },
    }
</script>

<style scoped>
@import "./setting.less";
</style>
<style>
    /*此style所有内容必须包裹_tag_list_modal_one以防css污染*/
    ._tag_list_modal_one  .ivu-checkbox-wrapper{
    }
    ._tag_list_modal_one  .ivu-checkbox-wrapper .ivu-checkbox-inner{
        width : 20px ;
        height: 20px;
    }
    ._tag_list_modal_one  .ivu-checkbox-checked .ivu-checkbox-inner:after{
        top : 2px;
        left: 6px;
        width: 6px;
        height: 12px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/company/tag/Setting.vue